/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

App.ready(() => App.invites.init());


App.invites = {
  init() {
    return $(document)
      .off("change", ".js-invite-sender", App.invites.sender_changed)
      .on("change", ".js-invite-sender", App.invites.sender_changed)

      .off("change keypress keyup paste", ".js-invite-addresses", App.invites.addresses_changed)
      .on("change keypress keyup paste", ".js-invite-addresses", App.invites.addresses_changed)

      .off("click", ".js-invite-add-more", App.invites.add_more)
      .on("click", ".js-invite-add-more", App.invites.add_more)

      .off("change", ".js-contact-invitation-group-select", App.invites.group_changed)
      .on("change", ".js-contact-invitation-group-select", App.invites.group_changed)

      .off("click", ".js-invite-switch-to-detailed", App.invites.switch_to_detailed)
      .on("click", ".js-invite-switch-to-detailed", App.invites.switch_to_detailed);
  },


  // "Switch to Invite with names" link under the Quick invite box: same as clicking that pill
  switch_to_detailed(evt) {
    evt.preventDefault();
    return $(".js-invite-mode-detailed").closest("label").click();
  },


  add_more(evt) {
    let count = $(".js-invite-detailed-rows .form-group").length + 1;
    if (count < 10) { count = `0${count}`; }

    if (count > 25) {
      $(".js-invite-add-more").prop("disabled", true);
      return;
    } else {
      $(".js-invite-add-more").prop("disabled", false);
    }

    const html = $(`\
<div class='form-group'> \
<label> \
Invite ${count} \
<div class='input-group multi-text'> \
<input class='form-control' name='contact_inviter[first_names][]' placeholder='First Name' type='text'> \
<input class='form-control' name='contact_inviter[last_names][]' placeholder='Last Name' type='text'> \
<input class='form-control' name='contact_inviter[phones][]' placeholder='Phone' type='tel'> \
</div> \
</label> \
</div>\
`);
    return $(".js-invite-detailed-rows").append(html);
  },


  addresses_changed(evt) {
    const $field = $(evt.currentTarget);
    const new_vals = $field.val().split(/[\n\r,]/).map(function(item) {
                // console.log 'item: ', item
                if (/[a-z]/i.test(item)) {
                  // email
                  return item.trim();
                } else {
                  // phone
                  return item.replace(/[\-\(\)\.\ ]/g, '').trim();
                }
    });

    return $field.val(new_vals.join("\n"));
  },


  sender_changed(evt) {
    let val = $(this).find("option:selected").text().trim();

    if (val.length > 16) {
      val = val.substr(0, 14) + "..";
    }

    return $(".js-invite-preview-from-name").text(val);
  },


  group_changed(evt) {
    const group_name = $(this).find("option:selected").data("name");
    return $(".js-contact-invitation-group-name").text(group_name);
  },


  // After the form is submitted
  invited(json) {
    if (json.valid) {
      return App.modals.close_all();
    } else {
      if (json.bad_addresses.length > 0) { $(".js-invite-addresses").val(json.bad_addresses.join("\n")); }
      new App.FormErrors(json);
      this.remove_good_addresses(json.good_addresses);
      return $(".modal-content").scrollTo(0,0);
    }
  },


  // After submitting, if there are both good and bad addresses,
  // remove the good ones so the user can correct the bad ones
  // (applies to detailed mode)
  remove_good_addresses(good_addresses) {
    const is_detailed = $(".js-invite-mode-detailed").prop("checked");
    if (is_detailed) {
      return $(".js-invite-detailed-rows .form-group").each(function() {
        const $row = $(this);
        const number = $row.find(".js-invite-phone").val();
        if (good_addresses.includes(number)) {
          return $row.fadeOut(function() { return $(this).remove(); });
        } else {
          if (number !== "") { return $row.addClass("invalid-group"); }
        }
      });
    }
  }
};
